import { toNumber } from './Utils';

export const formatCuit = (value: string) => {
  const cuit = value.replace(/\D/g, '');
  const part1 = cuit.slice(0, 2);
  const part2 = cuit.slice(2, 10);
  const part3 = cuit.slice(10, 11);

  if (cuit.length > 10) {
    return `${part1}-${part2}-${part3}`;
  } else if (cuit.length > 2) {
    return `${part1}-${part2}`;
  } else {
    return part1;
  }
};

export const formatCurrency = (
  value: string | number,
  allowNegative: boolean = false
) => {
  if (value === null || value === undefined || value === '') return 0;

  let sign = '';
  let num: number;

  if (typeof value === 'number') {
    num = value;
  } else {
    let cleanValue = value.toString().trim();
    if (allowNegative && cleanValue.startsWith('-')) {
      sign = '-';
      cleanValue = cleanValue.substring(1);
    }
    num = toNumber(cleanValue);
  }

  if (isNaN(num)) num = 0;

  if (Number.isInteger(num) || (num * 100) % 100 === 0) {
    return (
      sign +
      num.toLocaleString('es-AR', {
        maximumFractionDigits: 0,
      })
    );
  }

  const [integer, decimal] = num
    .toLocaleString('es-AR', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    })
    .split(',');

  let trimmedDecimal = decimal;
  if (decimal) {
    trimmedDecimal = decimal.replace(/0+$/, '');
  }

  return sign + integer + (trimmedDecimal ? ',' + trimmedDecimal : '');
};

export const adjustWidthTable = (baseWidth: number, adjustment: number) =>
  `${baseWidth + adjustment}px`;

// New responsive width function
export const getResponsiveColumnWidth = (columnType: 'cuit' | 'name' | 'company' | 'date' | 'amount' | 'status') => {
  const widths = {
    cuit: '140px',        // Fixed width for CUIT (consistent format)
    name: '180px',        // Fixed width for names
    company: 'minmax(200px, 1fr)', // Flexible width for company names
    date: '120px',        // Fixed width for dates
    amount: '160px',      // Fixed width for amounts
    status: '160px',      // Fixed width for status badges
  };
  return widths[columnType];
};

export const cuitMask = (value: string) => {
  const cuit = value.replace(/\D/g, '');
  if (cuit.length <= 2) return cuit;
  if (cuit.length <= 10) {
    return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}`;
  }
  return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10, 11)}`;
}
